module.exports = __webpack_public_path__ + "static/img/home_img_qyjj2.249edc2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home_img_qyjj2.png
// module id = 7ULE
// module chunks = 2